import { Box, List, ListItem, IconButton, Stack, Typography } from '@mui/material';

import type { PaymentSummaryProps } from '../../models';
import Iconify from '../iconify';
import { fCurrency } from '../../utils/formatNumber';

export interface InvoicesProps {
	transactions: PaymentSummaryProps['transactions'];
}

export const Invoices = ({ transactions = [] }: InvoicesProps) => {
	const content = transactions.every((txn) => {
		return txn.invoiceUrlPDF === null;
	}) ? (
		<Box component="section" sx={{ p: 4, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
			<Typography variant="h6" color="grey.500">
				Looks like there are no invoices for you to view right now.
			</Typography>
		</Box>
	) : (
		<List>
			{transactions
				.filter((txn) => {
					return txn.invoiceUrlPDF;
				})
				.map((transaction) => {
					return (
						<ListItem
							key={transaction.invoiceId}
							sx={{
								pl: 0,
							}}
							secondaryAction={
								<Stack direction="row" spacing={0.5}>
									<IconButton
										edge="end"
										aria-label="download"
										onClick={() => {
											const link = document.createElement('a');
											link.href = transaction.invoiceUrlPDF;
											link.download = `${transaction.invoiceId}.pdf`;
											link.rel = 'noopener noreferrer';
											document.body.appendChild(link);
											link.click();
											document.body.removeChild(link);
										}}
									>
										<Iconify
											icon={'eva:cloud-download-outline'}
											sx={{
												color: 'brand.main',
											}}
										/>
									</IconButton>
								</Stack>
							}
						>
							{transaction.amountTotal ? (
								<Typography>
									{transaction.invoiceId} - ({fCurrency(transaction.amountTotal)})
								</Typography>
							) : (
								<Typography>{transaction.invoiceId}</Typography>
							)}
						</ListItem>
					);
				})}
		</List>
	);

	return <>{content}</>;
};
